import { useDispatch } from 'react-redux';
import { redeemModalToggle } from '@/actions/payment';
import { useCallback } from 'react';

/**
 * Hook to toggle the redeem modal
 * @returns {function} $redeemModalToggle - The function to toggle the redeem modal
 */
const useRedeemModalToggle = () => {
  const dispatch = useDispatch();

  return useCallback(() => dispatch(redeemModalToggle(false)), [dispatch]);
};

export default useRedeemModalToggle;
